import "./AboutMe.module.css";
import Header from "@/reusable_sections/Header";
import TheAlmariaPhilosophy from "./sections/TheAlmariaPhilosophy";
import FromStoreToDoor from "./sections/FromStoreToDoor";
import Footer from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Header />
      <TheAlmariaPhilosophy />
      <FromStoreToDoor />
      <Footer />
    </div>;
}